import { ISupplier } from '@drone-parts.garphild.pro/interfaces';
import { useState } from 'react';
import { Button, Form, Input } from "antd";
import { observer } from 'mobx-react-lite';

/* eslint-disable-next-line */
export interface AddSupplierFormProps {
  onSubmit: (supplier: ISupplier) => void;
}

export function AddSupplierForm(props: AddSupplierFormProps) {
  const { onSubmit } = props;

  const [supplier, setSupplier] = useState<ISupplier>({
    name: '',
    website: '',
    sections: [],
    id: 0,
  });

  const setField = (field: keyof ISupplier, value: any) => {
    setSupplier({
      ...supplier,
      [field]: value,
    });
  };

  return (
    <div>
      <Form>
        <Form.Item label="Name">
          <Input value={supplier.name} onInput={(e) => setField('name', e.currentTarget.value)} />
        </Form.Item>
        <Button onClick={() => {
          onSubmit(supplier);
        }}>Submit</Button>
      </Form>
    </div>
  );
}

export default observer(AddSupplierForm);
